import { Injectable, inject } from "@angular/core";
import { Auth, signInWithPopup, getAuth } from "@angular/fire/auth";
import { GoogleAuthProvider } from "firebase/auth";
import { SharedService } from "../shared.service";
import { State, Store } from "@ngrx/store";
import { AppState } from "../app.state";
import { resetStore } from "../states/login/actions";
import { Dialog } from "@angular/cdk/dialog";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  auth = inject(Auth);
  share = inject(SharedService);
  store: Store<AppState> = inject(Store);
  dialog = inject(Dialog);

  async loginPopup() {
    const provider = new GoogleAuthProvider();
    return await signInWithPopup(this.auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential?.accessToken;
        return {
          error: false,
          token: token,
          credential: credential,
          uid: result.user.uid,
          email: result.user.email,
          photo: result.user.photoURL,
        };
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);
        return { error: error, token: false };
      });
  }

  logout() {
    this.dialog.closeAll();
    this.auth.signOut();
    this.share.resetStore();
    this.store.dispatch(resetStore());
  }
}
